function mapGetOrInsert(map, key, defValCallback) {
    if (map.has(key)) {
        return map.get(key);
    } else {
        const value = defValCallback();
        map.set(key, value);
        return value;
    }
}

const EmptySet = new Set();

class ActionReferenceMap {
    constructor(actions) {
        this._isObjectInActions = new Map();

        for (const action of actions) {
            const { systemAction, value } = action;
            const objectUuid = value && value.objectUuid;

            if (systemAction && value && objectUuid) {
                const objInActions = mapGetOrInsert(this._isObjectInActions, objectUuid, () => new Set());
                objInActions.add(systemAction);
            }
        }
    }

    isObjectReferredByActions(objectUuid, systemAction) {
        const objInActions = this._isObjectInActions.get(objectUuid);
        return (objInActions || EmptySet).has(systemAction);
    }
}

module.exports = ActionReferenceMap;
